import { render } from "./Prospecto.vue?vue&type=template&id=59241763"
import script from "./Prospecto.vue?vue&type=script&lang=js"
export * from "./Prospecto.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__